var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "smart-table" }, [
    _c(
      "div",
      { staticClass: "grid_table_holder" },
      [
        _c("v-table", {
          staticClass: "table_beauty",
          attrs: {
            data: _vm.rowData,
            "current-page": _vm.currentPage,
            "page-size": _vm.pageSize,
            filters: _vm.filters,
            "hide-sort-icons": _vm.hideSortIcons
          },
          on: {
            "update:currentPage": function($event) {
              _vm.currentPage = $event
            },
            "update:current-page": function($event) {
              _vm.currentPage = $event
            },
            totalPagesChanged: function($event) {
              _vm.totalPages = $event
            }
          },
          scopedSlots: _vm._u(
            [
              {
                key: "head",
                fn: function() {
                  return [
                    _c("thead", [
                      _c(
                        "tr",
                        _vm._l(_vm.columns, function(col, index) {
                          return _c(
                            "v-th",
                            {
                              key: "column_" + index,
                              staticClass: "th",
                              class: col.headerClass,
                              attrs: {
                                "default-sort": col.defaultSort,
                                "sort-key": col.name
                              }
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.$t(col.displayName)) +
                                  "\n              "
                              ),
                              col.tooltipText
                                ? _c("i", {
                                    directives: [
                                      {
                                        name: "tooltip",
                                        rawName: "v-tooltip.right",
                                        value: _vm.$t(col.tooltipText),
                                        expression: "$t(col.tooltipText)",
                                        modifiers: { right: true }
                                      }
                                    ],
                                    staticClass: "fa fa-question-circle m-l-5",
                                    attrs: { "aria-hidden": "true" }
                                  })
                                : _vm._e()
                            ]
                          )
                        }),
                        1
                      )
                    ])
                  ]
                },
                proxy: true
              },
              {
                key: "body",
                fn: function({ displayData }) {
                  return [
                    _c(
                      "tbody",
                      _vm._l(displayData, function(row, index) {
                        return _c(
                          "tr",
                          {
                            key: index,
                            class: _vm.getRowClass(row, index),
                            attrs: { row: row }
                          },
                          _vm._l(_vm.columns, function(col, colIndex) {
                            return _c(
                              "td",
                              {
                                key: col.key + "_" + colIndex + "_" + index,
                                class: col.cellClass,
                                on: {
                                  click: function($event) {
                                    return _vm.$emit("click", {
                                      row,
                                      index,
                                      col,
                                      colIndex
                                    })
                                  }
                                }
                              },
                              [
                                _vm._t(
                                  _vm.$scopedSlots[`col:${colIndex + 1}`]
                                    ? `col:${colIndex + 1}`
                                    : "cell",
                                  function() {
                                    return [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            col.valueFormatter
                                              ? col.valueFormatter({
                                                  value: row[col.key]
                                                })
                                              : row[col.key]
                                          ) +
                                          "\n              "
                                      )
                                    ]
                                  },
                                  null,
                                  {
                                    row,
                                    index,
                                    col,
                                    colIndex,
                                    value: col.valueFormatter
                                      ? col.valueFormatter({
                                          value: row[col.key]
                                        })
                                      : row[col.key]
                                  }
                                )
                              ],
                              2
                            )
                          }),
                          0
                        )
                      }),
                      0
                    )
                  ]
                }
              }
            ],
            null,
            true
          )
        })
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "pagination-min" }, [
      _c(
        "div",
        { staticClass: "text-center p-7" },
        [
          _c("smart-pagination", {
            attrs: {
              "current-page": _vm.currentPage,
              "total-pages": _vm.totalPages,
              "max-page-links": _vm.maxPageLinks
            },
            on: {
              "update:currentPage": function($event) {
                _vm.currentPage = $event
              },
              "update:current-page": function($event) {
                _vm.currentPage = $event
              }
            }
          })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }